export const POSITIONS = {
    LEFT: 'left',
    RIGHT: 'right',
    CENTER: 'center',
};
